import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

const DealInfoBox = ({
  show,
  children,
  className,
  isArrowVisible = true,
  iconPosition = 'right',
}) => {
  const theme = useContext(ThemeContext);
  if (!show) {
    return null;
  }
  const afterStyles = isArrowVisible
    ? `
    .info-box:after {
      content: '';
      width: 12px;
      height: 12px;
      border-width: 0px 1px 1px 0px;
      right: 20px;
      border-style: solid;
      position: absolute;
      z-index: 1;
      transform: rotate(45deg);
      bottom: -7px;
    }
    .info-box--info:after {
      background-color: ${theme.colors.infoboxbg};
      border-color: ${theme.colors.infoboxborder};
    }
  `
    : '';

  return (
    <>
      <div className={classNames('info-box', `info-box--info`, className)}>
        {iconPosition === 'left' && (
          <FontAwesomeIcon
            icon={faExclamationCircle}
            style={{ height: 18, marginRight: '2%', width: 18 }}
          />
        )}
        <div className="info-box__content">{children}</div>
        {iconPosition === 'right' && (
          <FontAwesomeIcon
            icon={faExclamationCircle}
            style={{ height: 18, width: 18 }}
          />
        )}
      </div>
      <style jsx>{`
        .info-box {
          position: relative;
          display: flex;
          align-items: center;
          padding: 8px;
          display: flex;
          margin-bottom: 8px;
          width: 100%;
          max-width: 648px;
        }
        .info-box--info {
          color: ${theme.colors.infoboxborder};
          border: 1px solid ${theme.colors.infoboxborder};
          background-color: ${theme.colors.infoboxbg};
        }
        ${afterStyles}
        .info-box__content {
          flex-grow: 1;
          margin-right: 12px;
        }
      `}</style>
    </>
  );
};

DealInfoBox.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  iconPosition: PropTypes.string,
  isArrowVisible: PropTypes.bool,
  show: PropTypes.bool,
};

export default DealInfoBox;
